import { render, staticRenderFns } from "./CommEmailModalMobile.vue?vue&type=template&id=ec6e32a2&"
import script from "./CommEmailModalMobile.vue?vue&type=script&lang=js&"
export * from "./CommEmailModalMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports